<template>
	<div class="w-full p-6 print:pt-3 print:pb-0">
		<h2
			class="form-title pb-6 text-2xl font-bold print:mb-3 print:border-b-2 print:border-slate-900 print:pt-2 print:pb-3 print:text-sm/0"
		>
			{{ t('plan.sectionTitle.specialInstructions') }}
		</h2>

		<CopyButtonList
			field-or-section="specialInstructions"
			:active-index="activePlanIndex"
			class="print:hidden"
		/>

		<section>
			<FormKit
				id="specialInstructions"
				name="specialInstructions"
				type="group"
			>
				<div
					class="section-grid-row grid grid-cols-3 gap-2 *:w-full *:max-w-none"
				>
					<FormKit
						type="textarea"
						auto-height
						name="flowerType"
						:label="t('plan.flowerType')"
					/>

					<FormKit
						type="textarea"
						auto-height
						name="colorPreferences"
						:label="t('plan.colorPreferences')"
					/>
					<FormKit
						type="textarea"
						auto-height
						name="musicPreference"
						:label="t('plan.musicPreference')"
					/>
				</div>

				<div class="section-grid-row grid grid-cols-1 gap-2">
					<div class="*w-full flex items-center gap-2">
						<FormKit
							type="textarea"
							auto-height
							outer-class="max-w-none"
							name="casketBearers"
							:label="t('plan.casketBearers')"
						/>
						<FormKit
							type="checkbox"
							outer-class="checkbox-inline mb-0! grow-0"
							:label="t('plan.wantsToNotifyBearers')"
							name="wantsToNotifyBearers"
						/>
					</div>
				</div>

				<div class="section-grid-row grid grid-cols-1 gap-2">
					<div class="*w-full flex items-center gap-2">
						<FormKit
							type="textarea"
							auto-height
							outer-class="max-w-none"
							name="obitPublications"
							:label="t('plan.obitPublications')"
						/>

						<FormKit
							type="checkbox"
							outer-class="checkbox-inline mb-0! grow-0"
							:label="t('plan.wantsObitPhoto')"
							name="wantsObitPhoto"
						/>
					</div>
				</div>
			</FormKit>
		</section>
	</div>
</template>

<script setup lang="ts">
import CopyButtonList from '@/components/presentation/CopyButtonList.vue'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

defineProps<{
	activePlanIndex: number
}>()
</script>
